// Silent context for a feedback ticket: pull site/inspection ids out of the
// current route so a two-line report is actionable without asking the user.
const UUID = '([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})';

export function feedbackContextFromPath(pathname: string): {
  route: string;
  site_id: string | null;
  inspection_id: string | null;
} {
  const site =
    pathname.match(new RegExp(`/sites/${UUID}`, 'i')) ??
    pathname.match(new RegExp(`/lite/inspect/${UUID}`, 'i'));
  const inspection = pathname.match(new RegExp(`/inspections/${UUID}`, 'i'));
  return {
    route: pathname.slice(0, 300),
    site_id: site ? site[1] : null,
    inspection_id: inspection ? inspection[1] : null,
  };
}
